import Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { itemTransactionConstants, itemTransactionStatus } from '@bibliocommons/utils-item';
import AvailabilityDetailActions from 'app/actions/AvailabilityDetailActions';
import GroupSearchFeedbackActions from 'app/actions/GroupSearchFeedbackActions';
import { selectActiveHoldsByMetadataId } from 'app/selectors/HoldsSelector';
import { selectCurrentUser } from 'app/selectors/AuthSelector';
import { selectCurrentSiteScopes } from 'app/selectors/ScopeSelector';
import { selectShelvesForCurrentUser } from 'app/selectors/ShelfSelector';
import { selectCurrentLibrary } from 'app/selectors/LibrarySelector';
import { selectCheckoutsByMetadataId } from 'app/selectors/CheckoutSelector';
import ManifestationListItem from './ManifestationListItem';

export class ManifestationListItemContainer extends React.PureComponent {
  render() {
    const {
      hold,
      materialType,
      hasItemLevelHoldableItems,
      checkout,
      shelfItem,
      availabilityDetailActions,
      groupSearchFeedbackActions,
      catalogSearchOptions,
      currentUser,
      item,
      drawerOpen,
      showGroupingDebug,
      searchScopeIsCurrent,
      showHoldCount,
      reciprocalRank
    } = this.props;

    const status = itemTransactionStatus(hold, materialType, hasItemLevelHoldableItems, checkout);
    let editable = false;

    if (
      [itemTransactionConstants.CANCEL_HOLD_BUTTON, itemTransactionConstants.DIGITAL_READING_LINKS].includes(status) ||
      shelfItem
    ) {
      editable = true;
    }

    return (
      <ManifestationListItem
        availabilityDetailActions={availabilityDetailActions}
        groupSearchFeedbackActions={groupSearchFeedbackActions}
        catalogSearchOptions={catalogSearchOptions}
        currentUser={currentUser}
        item={item}
        drawerOpen={drawerOpen}
        editable={editable}
        showGroupingDebug={showGroupingDebug}
        searchScopeIsCurrent={searchScopeIsCurrent}
        showHoldCount={showHoldCount}
        reciprocalRank={reciprocalRank}
      />
    );
  }
}

ManifestationListItemContainer.propTypes = {
  materialType: PropTypes.string,
  hasItemLevelHoldableItems: PropTypes.bool,
  item: ImmutablePropTypes.map,
  shelfItem: ImmutablePropTypes.map,
  availabilityDetailActions: PropTypes.objectOf(PropTypes.func).isRequired,
  groupSearchFeedbackActions: PropTypes.objectOf(PropTypes.func).isRequired,
  catalogSearchOptions: ImmutablePropTypes.map,
  currentUser: ImmutablePropTypes.map,
  drawerOpen: PropTypes.bool,
  checkout: ImmutablePropTypes.mapContains({
    id: PropTypes.string
  }),
  hold: ImmutablePropTypes.mapContains({
    id: PropTypes.string,
    status: PropTypes.string
  }),
  searchScopeIsCurrent: PropTypes.bool,
  showHoldCount: PropTypes.bool,
  reciprocalRank: PropTypes.number,
  showGroupingDebug: PropTypes.bool
};

ManifestationListItemContainer.displayName = 'ManifestationListItemContainer';

const mapStateToProps = (state, ownProps) => {
  const library = selectCurrentLibrary(state);
  const itemId = ownProps.item.get('id');
  const currentUser = selectCurrentUser(state);
  const shelfItem = selectShelvesForCurrentUser(state).get(itemId);
  const holds = selectActiveHoldsByMetadataId(state).get(itemId, Immutable.List());
  const checkouts = selectCheckoutsByMetadataId(state).get(itemId, Immutable.List());
  const policy = state.getIn(['entities', 'bibs', itemId, 'policy'], Immutable.Map());
  const currentScopeId = selectCurrentSiteScopes(state)
    .last()
    .get('scopeId');
  const searchScopeIsCurrent = state.getIn(['search', 'catalogSearch', 'scope']) === currentScopeId;
  const showHoldCount = library.get('showHoldCountInSearch');

  return {
    shelfItem,
    hold: holds.size === 1 ? holds.first() : null,
    holdable: state.getIn(['entities', 'bibs', itemId, 'policy', 'holdable'], false),
    materialType: state.getIn(['entities', 'bibs', itemId, 'policy', 'materialType']),
    hasItemLevelHoldableItems: policy.get('itemLevelHoldableItems'),
    checkout: checkouts.first(),
    catalogSearchOptions: state.getIn(['search', 'catalogSearchOptions']),
    currentUser,
    showGroupingDebug:
      currentUser &&
      currentUser.get('showGroupingDebug') &&
      state.getIn(['search', 'catalogSearch', 'view']) === 'grouped',
    searchScopeIsCurrent,
    showHoldCount
  };
};

const mapDispatchToProps = dispatch => ({
  availabilityDetailActions: bindActionCreators(AvailabilityDetailActions, dispatch),
  groupSearchFeedbackActions: bindActionCreators(GroupSearchFeedbackActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(ManifestationListItemContainer);
